import React from 'react';
import { Grid, Box, Typography, TextField, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';

import { buildLeafletLayerFromTile } from 'src/scenes/Project/scenes/Analytics/smaAnalyticsHelper';
import { fetchStatusEnum } from 'src/utils/enums/fetchStatusEnum';


const { LOADING, SUCCESS } = fetchStatusEnum;

const SelectComparisonYears = ({ yearsSelected, setYearSelected, setComp, onUpdate, projectId, setFetchStatus, getTitilerUrl }) => {

  const { left, right, years } = yearsSelected;
  const onUpdateYear = side => async year => {
    setYearSelected(prev => ({ ...prev, [side]: year.target.value }));
    setFetchStatus(LOADING);
    setComp(prev => ({ ...prev, loading: true }));
    const updatedYear = await onUpdate({ projectId, year: year.target.value,
      side: side === 'left' ? 'leftYear' : 'rightYear',
    });
    setComp(prev => {
      const compUpdated = { ...prev };
      if (updatedYear) {
        if (updatedYear.leftAsset) {
          compUpdated['left'].indicator = buildLeafletLayerFromTile(getTitilerUrl(updatedYear.leftAsset.assetId));
          compUpdated['right'].indicator = buildLeafletLayerFromTile(getTitilerUrl(updatedYear.rightAsset.assetId));
        } else {
          compUpdated[side].indicator = buildLeafletLayerFromTile(updatedYear.url);
        }
      }
      setFetchStatus(SUCCESS);
      return compUpdated;
    });
  };

  return <Grid container>
    <Grid item xs={6}>
      <Box mb={3} pr={1}>
        <Typography variant="body2">Año izquierda</Typography>
        <TextField
          select
          fullWidth
          value={left}
          onChange={onUpdateYear('left')}
          variant="outlined"
          size="small"
        >
          {years.map(year => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Grid>
    <Grid item xs={6}>
      <Box mb={3} pl={1}>
        <Typography variant="body2">Año derecha</Typography>
        <TextField
          select
          fullWidth
          value={right}
          onChange={onUpdateYear('right')}
          variant="outlined"
          size="small"
        >
          {years.map(year => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Grid>
  </Grid>;
};

SelectComparisonYears.propTypes = {
  yearsSelected: PropTypes.object.isRequired,
  setYearSelected: PropTypes.func.isRequired,
  setComp: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  setFetchStatus: PropTypes.func.isRequired,
  getTitilerUrl: PropTypes.func,
};


export { SelectComparisonYears };